<template>
  <card class="custom-shadow-card-header custom-table-responsive">
    <div class="row">
      <div class="col-6 text-center">
        <label class="mb-3">{{ $t('common_words.image') }}</label>
        <el-upload
          :show-file-list="false"
          :auto-upload="false"
          :on-change="changeGeneralPhoto"
          ref="general-photo-uploader"
          class="avatar-uploader"
          :action="getAxiosURL()"
        >
          <img v-if="generalImageUrl" :src="generalImageUrl" class="general" />
          <em v-else class="el-icon-plus general-uploader-icon"></em>
          <div
            v-if="generalImageError"
            slot="tip"
            class="el-upload__tip text-danger"
          >
            {{ $t('common_words.jpg_notice') }}
          </div>
        </el-upload>
      </div>
      <div class="col-6 text-center">
        <label class="mb-3">{{ $t('common_words.observations') }}</label>
        <textarea v-model="generalObservation" class="form-control" rows="6">
        </textarea>
      </div>
    </div>
    <div class="row mt-5">
      <div class="table-responsive">
        <table class="table table-striped table-bordered not-last-td">
          <thead>
            <tr class="cusmtom-thead-color">
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.task') }}
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.type_of_task') }}
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.value') }}
              </th>
              <th
                v-if="photoColumn"
                scope="col"
                class="text-center p-3 custom-header-label"
              >
                {{ $t('common_words.image') }}
              </th>
              <th scope="col" class="text-center p-3 custom-header-label">
                {{ $t('common_words.observations') }}
                {{ $t('table.of') }}
                {{ $t('common_words.tasks') }}
              </th>
              <th
                v-if="observationBySubcategory"
                scope="col"
                class="text-center p-3 custom-header-label"
              >
                {{ $t('common_words.observations') }}
                {{ $t('table.of') }}
                {{ $t('audit.subcategories') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(task, index) in tasksForm" :key="index">
              <td class="text-center" style="min-width: 200px">
                <el-input
                  v-model="task.name"
                  disabled
                  type="text"
                  class="shadow-sm text-center required-areas"
                />
              </td>
              <td class="text-center" style="min-width: 200px">
                <el-input
                  :value="getCalificationDescription(task)"
                  disabled
                  type="textarea"
                  class="shadow-sm text-center required-areas"
                />
              </td>
              <td class="text-center" style="min-width: 200px">
                <component
                  :is="getValueType(task)"
                  v-model="task.value"
                  v-bind="getProps(task)"
                  ref="dinamicInput"
                ></component>
              </td>
              <td
                v-if="photoColumn"
                class="text-center"
                style="min-width: 200px"
              >
                <el-upload
                  v-if="task.photo_required === 1"
                  :show-file-list="false"
                  :auto-upload="false"
                  :on-change="(file) => changePhoto(file, index)"
                  class="avatar-uploader"
                  :ref="`photo-uploader-${index}`"
                  :action="getAxiosURL()"
                >
                  <img
                    v-if="task.imageUrl"
                    :src="task.imageUrl"
                    class="avatar"
                  />
                  <em v-else class="el-icon-plus avatar-uploader-icon"></em>
                  <div
                    v-if="task.imageError && task.imageError"
                    slot="tip"
                    class="el-upload__tip text-danger"
                  >
                    {{ $t('common_words.jpg_notice') }}
                  </div>
                  <div
                    v-if="task.showImageError"
                    slot="tip"
                    class="el-upload__tip text-danger"
                  >
                    {{ $t('common_words.observations') }}
                  </div>
                </el-upload>
              </td>
              <td class="text-center" style="min-width: 200px">
                <el-input
                  type="textarea"
                  :placeholder="$t('common_words.observations')"
                  v-model="task.observation"
                />
              </td>
              <td
                v-if="observationBySubcategory"
                class="text-center"
                style="min-width: 200px"
                :rowspan="getRowSpan(task.audit2_subcategory_id, index)"
                v-show="getRowSpan(task.audit2_subcategory_id, index) > 0"
              >
                <textarea
                  class="form-control"
                  :style="`height: ${
                    getRowSpan(task.audit2_subcategory_id, index) * 66
                  }px`"
                  v-model="subcategoryObservations[task.audit2_subcategory_id]"
                  :placeholder="$t('common_words.observations')"
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-12 mt-5">
        <div class="row">
          <div class="col-6 text-right">
            <button
              class="btn btn-fill btn-info btn-wd shadow-sm"
              @click="validateForm"
            >
              {{ $t('common_words.save_data') }}
            </button>
          </div>
          <div class="col-6">
            <button
              class="btn btn-fill btn-danger btn-wd shadow-sm"
              @click="deleteAll"
            >
              {{ $t('common_words.delete') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>
<script>
import { AXIOS_URL } from 'src/util/Util';
import DateCapture from 'src/components/Forms/DateCapture.vue';
import i18n from 'src/i18n';
import NumericCapture from 'src/components/Forms/NumericCapture.vue';
import SelectableCapture from 'src/components/Forms/SelectableCapture.vue';
import TextCapture from 'src/components/Forms/TextCapture.vue';
import TimeCapture from 'src/components/Forms/TimeCapture.vue';

export default {
  name: 'CaptureConfirm',
  components: {
    DateCapture,
    NumericCapture,
    SelectableCapture,
    TextCapture,
    TimeCapture,
  },
  props: {
    module: {
      type: String,
    },
    tasks: {
      type: Array,
      required: true,
    },
    subObservations: {
      type: Array,
      default: [],
    },
    farmId: {
      type: Number,
      required: true,
    },
    photoColumn: {
      type: Boolean,
      default: false,
    },
    observationBySubcategory: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      generalImage: null,
      generalImageUrl: null,
      generalImageError: null,
      generalObservation: null,
      tasksForm: [],
      showImageError: false,
      subcategoryObservations: {},
    };
  },
  methods: {
    getAxiosURL() {
      return AXIOS_URL;
    },
    getValueType(task) {
      const types = {
        Texto: 'TextCapture',
        Numérica: 'NumericCapture',
        Objetiva: 'SelectableCapture',
        Subjetiva: 'SelectableCapture',
        'Subjetiva 2': 'SelectableCapture',
        Única: 'SelectableCapture',
        Múltiple: 'SelectableCapture',
        'Fuente de Datos': 'SelectableCapture',
        'Fuente de Datos Múltiple': 'SelectableCapture',
        Fecha: 'DateCapture',
        Hora: 'TimeCapture',
      };
      return types[task.calification_type];
    },
    getProps(task) {
      let props = {};
      switch (task.calification_type) {
        case 'Numérica':
          props.min = Number(task.minimum);
          props.max = Number(task.maximum);
          if (task.value) {
            task.value = Number(task.value);
          }
          break;
        case 'Objetiva':
          props.items = ['NA', 'SI', 'NO'];
          if (task.is_required === 1) {
            props.items.shift();
          }
          break;
        case 'Subjetiva':
          props.items = [...Array(11).keys()];
          if (task.is_required !== 1) {
            props.items.unshift('NA');
          }
          break;
        case 'Subjetiva 2':
          props.items = [...Array(6).keys()];
          if (task.is_required !== 1) {
            props.items.unshift('NA');
          }
          break;
        case 'Única':
          switch (this.module) {
            case 'audit':
              props.items = [...task.audit_option_tasks];
              break;
            case 'quality':
              props.items = [...task.quality_option_tasks];
              break;
            case 'certification':
              props.items = [...task.certification_option_tasks];
              break;
            default:
              break;
          }
          props.objects = true;
          break;
        case 'Múltiple':
          switch (this.module) {
            case 'audit':
              props.items = [...task.audit_option_tasks];
              break;
            case 'quality':
              props.items = [...task.quality_option_tasks];
              break;
            case 'certification':
              props.items = [...task.certification_option_tasks];
              break;
            default:
              break;
          }
          props.multiple = true;
          props.objects = true;
          break;
        case 'Fuente de Datos':
          props.items = task.dataSource;
          props.objects = true;
          break;
        case 'Fuente de Datos Múltiple':
          props.items = task.dataSource;
          props.multiple = true;
          props.objects = true;
          break;
        case 'Texto':
          props.min = Number(task.minimum);
          props.max = Number(task.maximum);
          break;
      }
      return { ...props, id: task.id, required: task.is_required };
    },
    getCalificationDescription(task) {
      const descriptions = {
        Numérica: `${i18n.t('ad_audit.numeric_description')} ${
          task.minimum
        } ${i18n.t('common_words.and')} ${task.maximum}`,
        Objetiva: `${i18n.t('ad_audit.objective_description')}`,
        Subjetiva: `${i18n.t('ad_audit.subjective_description')}`,
        'Subjetiva 2': `${i18n.t('ad_audit.subjective_description')}`,
        Única: `${i18n.t('ad_audit.unique_description')}`,
        Múltiple: `${i18n.t('ad_audit.multiple_description')}`,
        'Fuente de Datos': `${i18n.t('ad_audit.data_source_description')}`,
        Fecha: `${i18n.t('ad_audit.date_description')}`,
        Hora: `${i18n.t('ad_audit.hour_description')}`,
        'Fuente de Datos Múltiple': `${i18n.t(
          'ad_audit.multiple_data_source_description'
        )}`,
        Texto: `${i18n.t('ad_audit.text_description')} ${task.minimum} ${i18n.t(
          'common_words.and'
        )} ${task.maximum} ${i18n.t('common_words.characters')}.`,
      };
      return descriptions[task.calification_type];
    },
    validateForm() {
      const validatedForm = !this.$refs.dinamicInput.some(
        (input) => input.validate() === false
      );
      let requiredPhotoIndex = null;
      const validatedFormPhotos = !this.$refs.dinamicInput.some((_, index) => {
        if (
          this.tasksForm[index].photo_required === 1 &&
          !this.tasksForm[index].photo &&
          this.tasksForm[index].is_required == 1
        ) {
          requiredPhotoIndex = index;

          return true;
        }
      });
      if (!validatedFormPhotos) {
        this.validateRequiredPhoto(requiredPhotoIndex);
      }
      if (validatedForm && validatedFormPhotos) {
        const data = {
          tasksForm: this.tasksForm,
          image: this.generalImage,
          observations: this.generalObservation,
          subcategoryObservations: this.subcategoryObservations,
        };
        this.$emit('save', data);
      }
    },
    validateRequiredPhoto(indexPhoto) {
      this.$refs[`photo-uploader-${indexPhoto}`][0].$el.classList.add(
        'avatar-uploader-bad'
      );
      this.$set(this.tasksForm, indexPhoto, {
        ...this.tasksForm[indexPhoto],
        showImageError: true,
      });
      setTimeout(() => {
        this.$refs[`photo-uploader-${indexPhoto}`][0].$el.classList.remove(
          'avatar-uploader-bad'
        );
        this.tasksForm[indexPhoto].showImageError = false;
      }, 5000);
    },
    validatePhoto(fileType, index) {
      const isJPG = ['image/jpeg', 'image/png'].includes(fileType);
      if (!isJPG) {
        if (this.$refs[`photo-uploader-${index}`][0]) {
          this.$refs[`photo-uploader-${index}`][0].$el.classList.add(
            'avatar-uploader-bad'
          );
          this.$set(this.tasksForm, index, {
            ...this.tasksForm[index],
            imageError: true,
          });
          setTimeout(() => {
            this.$refs[`photo-uploader-${index}`][0].$el.classList.remove(
              'avatar-uploader-bad'
            );
            this.tasksForm[index].imageError = false;
          }, 5000);
        }
        return false;
      }
      return true;
    },
    changePhoto(file, index) {
      const validatedPhoto = this.validatePhoto(file.raw.type, index);
      if (!validatedPhoto) {
        this.$refs[`photo-uploader-${index}`][0].clearFiles();
      } else {
        this.$set(this.tasksForm, index, {
          ...this.tasksForm[index],
          photo: file.raw,
          imageUrl: URL.createObjectURL(file.raw),
        });
      }
    },
    changeGeneralPhoto(file) {
      const isJPG = ['image/jpeg', 'image/png'].includes(file.raw.type);
      if (!isJPG) {
        this.$refs['general-photo-uploader'].clearFiles();
        this.$refs['general-photo-uploader'].$el.classList.add(
          'avatar-uploader-bad'
        );
        this.generalImageError = true;
        setTimeout(() => {
          this.$refs['general-photo-uploader'].$el.classList.remove(
            'avatar-uploader-bad'
          );
          this.generalImageError = false;
        }, 5000);
      } else {
        this.generalImage = file.raw;
        this.generalImageUrl = URL.createObjectURL(file.raw);
      }
    },
    deleteAll() {
      this.$emit('delete');
    },
    getRowSpan(subcategoryId, index) {
      const groupedTasks = this.tasksForm.filter(
        (t) => t.audit2_subcategory_id === subcategoryId
      );
      const firstIndex = this.tasksForm.findIndex(
        (t) => t.audit2_subcategory_id === subcategoryId
      );

      if (firstIndex === index) {
        return groupedTasks.length;
      } else {
        return 0;
      }
    },
  },
  created() {
    this.tasksForm = [...this.tasks];
    this.tasksForm.forEach((task) => {
      const subId = task.audit2_subcategory_id;
      if (!(subId in this.subcategoryObservations)) {
        const value =
          this.subObservations[subId] !== undefined
            ? this.subObservations[subId]
            : '';
        this.$set(this.subcategoryObservations, subId, value);
      }
    });
  },
};
</script>
